import { Message } from '../../common/components/Message';
import { AmountUnavailableMessage } from './amountRange';

interface UnavailableAmountStateProps {
    message: AmountUnavailableMessage;
}

export const UnavailableAmountState = ({ message }: UnavailableAmountStateProps) => (
    <Message
        headline={message.headline}
        detail="Update the sale amount or down payment, then find plans again."
    />
);
